import ConfigRequests from '../requests/ConfigRequests';
import { SET_CONFIG } from './types';

const requests = new ConfigRequests();

export const setConfig = (data) => ({
  type: SET_CONFIG,
  payload: data,
});

export const loadConfig = () =>
  requests.fetch({
    label: 'CONFIG',
    onSuccess: (data) => setConfig(data),
  });
